/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Blmodified_Name1Inputs */

const en_resources_blmodified_name1 = /** @type {(inputs: Resources_Blmodified_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery notes to re-issue`)
};

const fr_resources_blmodified_name1 = /** @type {(inputs: Resources_Blmodified_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BLs à rééditer`)
};

const es_resources_blmodified_name1 = /** @type {(inputs: Resources_Blmodified_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Albaranes a reeditar`)
};

const de_resources_blmodified_name1 = /** @type {(inputs: Resources_Blmodified_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu auszustellende Lieferscheine`)
};

const nl_resources_blmodified_name1 = /** @type {(inputs: Resources_Blmodified_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw uit te geven leveringsbonnen`)
};

/**
* | output |
* | --- |
* | "Delivery notes to re-issue" |
*
* @param {Resources_Blmodified_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_blmodified_name1 = /** @type {((inputs?: Resources_Blmodified_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Blmodified_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_blmodified_name1(inputs)
	if (locale === "fr") return fr_resources_blmodified_name1(inputs)
	if (locale === "es") return es_resources_blmodified_name1(inputs)
	if (locale === "de") return de_resources_blmodified_name1(inputs)
	return nl_resources_blmodified_name1(inputs)
});
export { resources_blmodified_name1 as "resources.blModified.name" }